import { NAVLIST,deepClone } from '@/utils/utils';
const machine = {
    state: {
        /**项目导航路由 */
        navList:deepClone(NAVLIST),
        /**个人中心导航 */
        personNavList:[
        ],
        /**后台系统导航 */
        magSysList:[],
        /**后台当前所在导航 */
        currentMagNav:{},
        menuList:[],
        horizontalMenuList:[],
        routeList:[],
        permissions :[],
        appList:[],
        appDetail:{},//应用详情
        /**个人中心当前所在导航 */
        currentNav:'',
        /**是否是全屏模式 */
        isBigMode:false,
        /**控制账号弹窗 */
        goLogin:'',
    },
    mutations: {
        /**修改导航 */
        updateNavList(state,data){
            state.navList=data||deepClone(NAVLIST);
        },
        /**未登录时的导航 */
        noLoginNavList(state){
            state.navList=deepClone(NAVLIST);
            var tenantId=sessionStorage.getItem('institutionTenantId');
            let el=state.navList.find(item=>item.value=='collegeCenter');
            if(el){
                el.show=tenantId?false:true;
            }
        },
        /**修改后台的导航列表 */
        changeMagSysList(state,value){
            state.magSysList=value;
        },
        /**修改后台当前所在导航 */
        changeCurrentMagNav(state,value){
            state.currentMagNav=value;
        },
        /**是否显示个人中心 */
        isShowPersonCenter(state,value){
        let el=state.navList.find(item=>item.value=='personCenter');
           if(el){
            el.show=value;
           }
        },
        /**是否显示院校中心 */
        changeShowCollegeCenter(state,value){
            if(!state.navList)return;
           let el=state.navList.find(item=>item.value=='collegeCenter');
           if(el){
            el.show=value;
           }
        },
        changeGoLogin(state,value){
            state.goLogin=value;
        },
        /**切换全屏模式 */
        changeMode(state,value){
            state.isBigMode=value;
        },
        /**修改个人中心当前所在导航 */
        changeCurrentNav(state,nav){
            state.currentNav=nav;
        },
        /**修改个人中心导航 */
        changePersonNavList(state,data){
            state.personNavList=data;
        },
        set_horizontal_menuList(state,value){
            state.horizontalMenuList = value;
        },
        set_menuList(state,value){
            state.menuList = value;
        },
        set_routeList(state,value){
            state.routeList = value;
        },
        set_permissions(state,value){
            state.permissions = value;
        },
        set_app(state,value){
           var index=value.findIndex((item)=>{
                return item.appCode==process.env.VUE_APP_APP_CODE;
            })
            if(index!=-1){
                value.splice(index,1);
                state.appList=value;
            }
        },
        set_app_detail(state,value){
            state.appDetail=value;
        }
    },
    actions: {
        setHorizontalMenuList({commit},value){
            commit("set_horizontal_menuList",value);
        },
        setMenuList({commit},value){
            commit("set_menuList",value);
            localStorage.setItem("m",JSON.stringify(value));
        },
        setRouteList({commit},value){
            commit("set_routeList",value);
        },
        setPermissions({commit},value){
            commit("set_permissions",value);
            localStorage.setItem("permission_list",value);
        },
        setApp({commit},value){
            commit("set_app",value);
        },
        setAppDetail({commit},value){
            commit("set_app_detail",value);
        }
    }
};
export default machine;
